// extracted by mini-css-extract-plugin
export default {"statusTitle":"styles_statusTitle__vV+xk","count":"styles_count__cxsy8"};